import { Action } from 'redux';

import { IAccount } from '@models';

import { RequestStatus } from './request';

export const GETTING_ACCOUNTS = 'GETTING_ACCOUNTS';
export const GOT_ACCOUNTS = 'GOT_ACCOUNTS';

export interface IAccountsAction extends Action {
  payload: IAccount[];
}

export interface IAccountsState {
  accounts: IAccount[];
  status: RequestStatus;
}

export type IAccountsActions = Action | IAccountsAction;
